<script>
import SearchForm from '@/components/Forms/search.vue'
import BoardProspectSteps from '@/components/Board/BoardProspectSteps.vue'
import ModalAddContact from '@/components/Modal/AddContact'

export default {
  name: 'BoardProspect',
  components: {
    SearchForm,
    BoardProspectSteps
  },
  data () {
    return {
      searchQuery: '',
      showAddContact: false,
      contentModal: ModalAddContact,
      modalData: { defaultType: 'Prospect' }
    }
  },
  methods: {
    handleSearch (query) {
      this.searchQuery = query
    },
    handleClearSearch () {
      this.searchQuery = ''
    },
    openAddContactModal () {
      this.showAddContact = true
    },
    closeAddContactModal () {
      this.showAddContact = false
    }
  }
}
</script>
<template>
	<section class="board-prospect">
		<h2 class="dashboard-title dashboard-title--medium">Parcours prospects</h2>
		<div class="board-prospect__searchbar">
			<SearchForm
				v-model="searchQuery"
				placeholder="Rechercher un prospect..."
				@search="handleSearch"
				@clear="handleClearSearch"
			/>
			<button class="dashboard-btn dashboard-btn--primary" @click="openAddContactModal">
				Nouveau prospect
			</button>
		</div>
		<div class="board-prospect__steps">
			<BoardProspectSteps :search-query="searchQuery" />
		</div>
		<base-modal :show="showAddContact" @close="closeAddContactModal" :content="contentModal" :data="modalData" />
	</section>
</template>

<style scoped>
.board-prospect {
	margin: 2rem 0;
}

.board-prospect__searchbar {
	display: flex;
  flex-wrap: wrap;
  gap: 1rem;
	justify-content: space-between;
	margin-top: 1rem;
	padding: 0.5rem;
	background: #fff;
	border-radius: 10px;

}
</style>


// WEBPACK FOOTER //
// BoardProspect.vue?8c103152